import React from "react";
import styled from "styled-components";

interface TextProps {
  children: React.ReactNode;
  className?: string;
  color?: string;
  margin?: string;
  type?: string;
}

const getStyles = (children: React.ReactNode, type?: string) => {
  // Type-based styling
  if (type) {
    switch (type) {
      case "chamber":
        return {
          textcolor: "#4a5568",
          backgroundColor: "#e2e8f0",
          fontWeight: "600",
          borderColor: "#cbd5e0",
        };
      case "step":
        return {
          textcolor: "#2b6cb0",
          backgroundColor: "#ebf8ff",
          fontWeight: "600",
          borderColor: "#90cdf4",
        };
      case "session":
        return {
          textcolor: "#553c9a",
          backgroundColor: "#faf5ff",
          fontWeight: "600",
          borderColor: "#c4b5fd",
        };
      case "vote":
        return {
          textcolor: "#c53030",
          backgroundColor: "#fed7d7",
          fontWeight: "600",
          borderColor: "#feb2b2",
        };
      case "amendmentNbr":
        return {
          textcolor: "#d69e2e",
          backgroundColor: "#fefcbf",
          fontWeight: "600",
          borderColor: "#f6e05e",
        };
      case "amendment":
        return {
          textcolor: "#38a169",
          backgroundColor: "#f0fff4",
          fontWeight: "600",
          borderColor: "#9ae6b4",
        };
      default:
        break;
    }
  }

  // Status-based styling (existing logic)
  if (children === "Adopté") {
    return {
      textcolor: "#89b97b",
      backgroundColor: "#f5fff2",
      fontWeight: "700",
      borderColor: "#89b97b",
    };
  } else if (
    children === "Tombé" ||
    children === "Retiré" ||
    children === "Rejeté" ||
    children === "Irrecevable" ||
    children === "Non soutenu" ||
    children === "Irrecevable 40"
  ) {
    return {
      textcolor: "#B97B7B",
      backgroundColor: "#FFF2F2",
      fontWeight: "700",
      borderColor: "#B97B7B",
    };
  } else if (children === "Discuté") {
    return {
      textcolor: "#828283",
      backgroundColor: "#F5F5F5",
      fontWeight: "700",
      borderColor: "#828283",
    };
  } else if (children === "Moyen") {
    return {
      textcolor: "#B9B07B",
      backgroundColor: "#FDF4E4",
      fontWeight: "700",
      borderColor: "#B9B07B",
    };
  } else if (children === "Haut") {
    return {
      textcolor: "#B97B7B",
      backgroundColor: "#FFF2F2",
      fontWeight: "700",
      borderColor: "#B97B7B",
    };
  } else if (children === "Faible") {
    return {
      textcolor: "#6e6e6e",
      backgroundColor: "#eeeeee",
      fontWeight: "700",
      borderColor: "#6e6e6e",
    };
  } else {
    return {
      textcolor: "#ffffff",
      backgroundColor: "#646464",
      fontWeight: "500",
      borderColor: "#646464",
    };
  }
};

const Container = styled.div<{ backgroundColor: string; borderColor: string }>`
  display: flex;
  padding: 0px 12px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 18px;
  background: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  width: fit-content;
`;

const Text = styled.span<{ textcolor: string; fontWeight: string }>`
  color: ${(props) => props.textcolor};
  font-family: "Sharp Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: ${(props) => props.fontWeight};
  line-height: 22px; /* 183.333% */
`;

const Category: React.FC<TextProps> = ({ children, type }) => {
  const { textcolor, backgroundColor, fontWeight, borderColor } = getStyles(
    children,
    type
  );

  return (
    <Container backgroundColor={backgroundColor} borderColor={borderColor}>
      <Text textcolor={textcolor} fontWeight={fontWeight}>
        {children}
      </Text>
    </Container>
  );
};

export default Category;
